export default "__VITE_ASSET__2CUJzCtb__"